module.exports = __webpack_public_path__ + "img/ap204.e702701d.jpg";